import React, { FunctionComponent, useContext } from 'react';

import PaginationContext from '../BasePaginationContainer/PaginationStore/PaginationContext';
import { IShowAllContainerProps } from './ShowAllContainer.types';

export const ShowAllContainer: FunctionComponent<IShowAllContainerProps> = props => {
  const { showAll, currPage = 0 } = useContext(PaginationContext);
  const { children, showAll: showAllOverride = showAll, itemsPerPage = 10 } = props;
  return (
    <>{Array.isArray(children) && !showAllOverride ? children.slice(currPage * itemsPerPage, (currPage + 1) * itemsPerPage) : children}</>
  );
};

export default ShowAllContainer;
